import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { api_url } from "../../../../../config/config";

const ClientSearchHitech = ({
  contractData,
  catalog,
  onAttachClient,
  clientExisteSurHitech,
}) => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [attachedClientId, setAttachedClientId] = useState(
    contractData?.client?.IdHitech || null,
  );
  const [searchIntitule, setSearchIntitule] = useState(
    contractData?.client?.Intitule || "",
  );
  const [searchSiren, setSearchSiren] = useState(
    contractData?.client?.Siren || "",
  );
  const [searchCode, setSearchCode] = useState("");

  // Synchroniser attachedClientId avec contractData.client.IdHitech
  useEffect(() => {
    setAttachedClientId(contractData?.client?.IdHitech || null);
  }, [contractData?.client?.IdHitech]);

  const handleAttachClient = (client) => {
    setAttachedClientId(client.id);
    onAttachClient(client.id);
    toast.success(`Client "${client.intitule}" rattaché avec succès`);
  };

  const handleSearchByCode = async () => {
    if (!searchCode.trim()) {
      toast.warning("Veuillez renseigner le  numéro client");
      return;
    }

    setIsSearching(true);
    setHasSearched(false);

    try {
      const params = new URLSearchParams();
      params.append("numero", searchCode);

      const response = await axios.get(
        `${api_url}clients/hitech/${catalog}/chercher-correspondances?${params.toString()}`,
      );

      setSearchResults(response.data);
      setHasSearched(true);

      if (response.data && response.data.length > 0) {
        toast.success(`${response.data.length} correspondance(s) trouvée(s)`);
      } else {
        toast.info("Aucune correspondance trouvée");
      }
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
      toast.error("Erreur lors de la recherche de correspondances");
      setSearchResults(null);
      setHasSearched(true);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchByIntituleSiren = async () => {
    if (!searchIntitule.trim() || !searchSiren.trim()) {
      toast.warning("Veuillez renseigner l'intitulé ET le SIREN");
      return;
    }

    setIsSearching(true);
    setHasSearched(false);

    try {
      const params = new URLSearchParams();
      params.append("intitule", searchIntitule);
      params.append("siren", searchSiren);

      const response = await axios.get(
        `${api_url}clients/hitech/${catalog}/chercher-correspondances?${params.toString()}`,
      );

      setSearchResults(response.data);
      setHasSearched(true);

      if (response.data && response.data.length > 0) {
        toast.success(`${response.data.length} correspondance(s) trouvée(s)`);
      } else {
        toast.info("Aucune correspondance trouvée");
      }
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
      toast.error("Erreur lors de la recherche de correspondances");
      setSearchResults(null);
      setHasSearched(true);
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <div className="client-search-hitech mb-4">
      <div className="card">
        <div className="card-header ">
          <h5 className="mb-0">
            <i className="fa fa-search mr-2" />
            Recherche de client sur HITECH
          </h5>
        </div>
        <div className="card-body">
          {clientExisteSurHitech ? (
            <div className="alert alert-success mb-3">
              <h6 className="alert-heading mb-2">
                <i className="fa fa-check-circle mr-2" />
                Client déjà rattaché sur HITECH
              </h6>
              <p className="mb-0">
                Ce client existe déjà sur HITECH. Le contrat lui sera
                automatiquement rattaché lors de la création.
              </p>
            </div>
          ) : (
            <div className="alert alert-info mb-3">
              <i className="fa fa-info-circle mr-2" />
              Recherchez si le client existe déjà sur HITECH avant de créer le
              contrat.
              <br />
              <small>
                Deux modes de recherche disponibles : par{" "}
                <strong>numéro client</strong> OU par couple{" "}
                <strong>intitulé + SIREN</strong> (les deux obligatoires).
              </small>
            </div>
          )}

          {!clientExisteSurHitech && (
            <>
              <div className="row mb-3 position-relative">
                {/* Colonne 1 : Recherche par code */}
                <div className="col-md-6">
                  <div className="border rounded p-3 h-100">
                    <h6 className="font-weight-bold mb-3">
                      <i className="fa fa-barcode mr-2" />
                      Recherche par numéro
                    </h6>
                    <div className="mb-3">
                      <label className="font-weight-bold">Numéro client</label>
                      <input
                        type="text"
                        className="form-control"
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                        placeholder="Ex : C000148"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") handleSearchByCode();
                        }}
                      />
                    </div>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={handleSearchByCode}
                      disabled={isSearching}
                    >
                      {isSearching ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-2" />
                          Recherche...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-search mr-2" />
                          Rechercher par code
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* Séparateur OU */}
                <div className="col-md-12 d-md-none text-center my-2">
                  <span className="badge badge-secondary">OU</span>
                </div>
                <div
                  className="d-none d-md-flex align-items-center justify-content-center"
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1,
                  }}
                >
                  <span className="badge badge-secondary">OU</span>
                </div>

                {/* Colonne 2 : Recherche par intitulé + SIREN */}
                <div className="col-md-6">
                  <div className="border rounded p-3 h-100">
                    <h6 className="font-weight-bold mb-3">
                      <i className="fa fa-building mr-2" />
                      Recherche par intitulé + SIREN
                    </h6>
                    <div className="mb-3">
                      <label className="font-weight-bold">
                        Intitulé <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={searchIntitule}
                        onChange={(e) => setSearchIntitule(e.target.value)}
                        placeholder="Saisissez l'intitulé"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") handleSearchByIntituleSiren();
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="font-weight-bold">
                        SIREN <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={searchSiren}
                        onChange={(e) => setSearchSiren(e.target.value)}
                        placeholder="Saisissez le SIREN"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") handleSearchByIntituleSiren();
                        }}
                      />
                    </div>
                    <p className="text-muted small mb-2">
                      <i className="fa fa-info-circle mr-1" />
                      <span className="text-danger">*</span> Les deux champs
                      sont obligatoires
                    </p>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={handleSearchByIntituleSiren}
                      disabled={isSearching}
                    >
                      {isSearching ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-2" />
                          Recherche...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-search mr-2" />
                          Rechercher par intitulé + SIREN
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {!clientExisteSurHitech && hasSearched && searchResults !== null && (
            <div className="mt-3">
              {searchResults.length === 0 ? (
                <div className="alert alert-warning">
                  <i className="fa fa-exclamation-triangle mr-2" />
                  Aucune correspondance trouvée. Le client doit être créé sur
                  HITECH au préalable.
                </div>
              ) : (
                <div className="alert alert-success">
                  <h6 className="alert-heading">
                    <i className="fa fa-check-circle mr-2" />
                    {searchResults.length} correspondance(s) trouvée(s)
                  </h6>
                  <div className="table-responsive mt-3">
                    <table className="table table-sm table-bordered mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Numéro</th>
                          <th>Intitulé</th>
                          <th>SIREN</th>
                          <th>Email</th>
                          <th>Téléphone</th>
                          <th style={{ width: "150px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResults.map((client, index) => (
                          <tr key={index}>
                            <td>{client.numero || "-"}</td>
                            <td>{client.intitule || "-"}</td>
                            <td>{client.siren || "-"}</td>
                            <td>{client.email || "-"}</td>
                            <td>{client.telephone || "-"}</td>
                            <td>
                              {attachedClientId === client.id ? (
                                <span className="badge badge-success">
                                  <i className="fa fa-check mr-1" />
                                  Rattaché
                                </span>
                              ) : (
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleAttachClient(client)}
                                >
                                  <i className="fa fa-link mr-1" />
                                  Rattacher
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientSearchHitech;
